import { AsYouTypeFormatter, PhoneNumberFormat, PhoneNumberUtil, PhoneNumber } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();
const removeUnwantedChar = (value: string) => `${value.replace(/\D/g, '')}`;

export const phoneFormat = (value: string, countryCode?: string, dialCode?: string): string => {
  //  istanbul ignore next
  if (!value) return '';

  let parsedValue = removeUnwantedChar(value);
  // istanbul ignore next
  if (dialCode && parsedValue.startsWith(dialCode)) {
    parsedValue = parsedValue.slice(dialCode.length);
  }

  const formatter = new AsYouTypeFormatter(countryCode ?? 'CA');
  let formattedValue = '';

  parsedValue.split('').forEach((c) => {
    formattedValue = formatter.inputDigit(c);
  });

  return formattedValue;
};

// this utils function supports formatting for australia as well but formats after the correct number is entered;
export const formatPhoneNumber = (phoneNumber: string, defaultCountry: string, withCountryCode = false): string => {
  // istanbul ignore next
  if (!phoneNumber) {
    return '';
  }
  // check for number is valid is removed as of now it will format every number with valid length of digits.
  try {
    const parsedValue = removeUnwantedChar(phoneNumber);

    const number: PhoneNumber = phoneUtil.parse(parsedValue, defaultCountry);

    const countryCode = number.getCountryCode();

    const intlFormatted = phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
    const prefix = `+${countryCode} `;

    return withCountryCode ? intlFormatted : intlFormatted.slice(prefix.length);
  } catch (err) {
    return phoneNumber;
  }
};
export const getPhoneRegion = (phoneNumber: string, code?: string): string => {
  if (!phoneNumber) return '';

  try {
    const parsedNumber = phoneUtil.parse(phoneNumber, code);
    const region = phoneUtil.getRegionCodeForNumber(parsedNumber);
    return region || '';
  } catch (err) {
    return '';
  }
};

export const formattedPhone = (phoneNumber: string, countryCode?: string): string => {
  if (!phoneNumber) return '';
  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode);
    return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
  } catch (err) {
    // istanbul ignore next
    console.error(`Failed to format phone number: ${phoneNumber}`, err);
    return '-';
  }
};
